import { BoardsApiStakeholder, Stakeholder } from '../../model/stakeholder';
import { STAKEHOLDER_TYPE, STAKEHOLDER_TYPE_CAMEL_CASE } from '../../services/backend-service/model/stakeholder-type';

const stakeholderCamelCaseToUppercase = {
  [STAKEHOLDER_TYPE_CAMEL_CASE.NOTSET]: STAKEHOLDER_TYPE.NOTSET,
  [STAKEHOLDER_TYPE_CAMEL_CASE.CITIZENS]: STAKEHOLDER_TYPE.CITIZENS,
  [STAKEHOLDER_TYPE_CAMEL_CASE.PROPERTY_OWNERS]: STAKEHOLDER_TYPE.PROPERTY_OWNERS,
  [STAKEHOLDER_TYPE_CAMEL_CASE.HEALTHCARE_PROVIDERS]: STAKEHOLDER_TYPE.HEALTHCARE_PROVIDERS,
  [STAKEHOLDER_TYPE_CAMEL_CASE.CITY_COUNCIL]: STAKEHOLDER_TYPE.CITY_COUNCIL,
  [STAKEHOLDER_TYPE_CAMEL_CASE.UTILITIES]: STAKEHOLDER_TYPE.UTILITIES,
};

export function toClientStakeholders(stakeholders: BoardsApiStakeholder[]): Stakeholder[] {
  return stakeholders.map((s) => ({
    id: s.id,
    name: s.name,
    ...(s.type ? { type: stakeholderCamelCaseToUppercase[s.type] } : {}),
  }));
}
